module.exports = __webpack_public_path__ + "img/Zain_KSA_logo.7d10b159.svg";